import { ProductPriceTierDeleteResponseType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

/** @deprecated Use useProductPriceListDelete for the canonical PriceList contract. */
export const useProductPriceTierDelete = (productPriceTierId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `product-price-tiers/${productPriceTierId}`,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as ProductPriceTierDeleteResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
    },
  });
};
